import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {AssigmentModel} from "../../../schemas/assigment.model";
import {SearchDialogComponent} from "../search-dialog/search-dialog.component";
import {AssigmentService} from "../../../services/assigment.service";
import {MessageService} from "primeng/api";
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthTokenService } from 'src/app/services/auth-token.service';
import { LanguageService } from 'src/app/shared/language/language.service';
import { EncodeDecode } from 'src/app/shared/encode-decode/EncodeDecode';


@Component({
    selector: 'app-assignment-dialog',
    templateUrl: './assignment-dialog.component.html',
    styleUrls: ['./assignment-dialog.component.scss'],
    providers: [DialogService, MessageService],
    standalone: false
})
export class AssignmentDialogComponent implements OnInit {
    assignationForm: FormGroup = new FormGroup({});
    assignment!: AssigmentModel;
    assignmentRequest!: AssigmentModel;
    currentLanguage: string = 'IN';

    language: string = 'IN';
    mailEncript !: string;
    user!: string;

    constructor(private fb: FormBuilder,
                public config: DynamicDialogConfig,
                public dialogService: DialogService,
                private messageService: MessageService,
                private ref: DynamicDialogRef,
                private assigmentService: AssigmentService,
                private translate: TranslateService,
                private route: ActivatedRoute,
                private __languageService: LanguageService,
                private __router: Router,
                private __authService: AuthTokenService) {
                    this.initializeTranslations();
    }


    ngOnInit(): void {

        this.language = this.route.snapshot.paramMap.get('language')!;
        this.__languageService.setLanguage(this.language);
        this.mailEncript = this.route.snapshot.paramMap.get('email')!;
        try {
            let mail = EncodeDecode.b64DecodeUnicode(this.mailEncript);

            this.__authService.validateAccessUser(mail, 'SOM').subscribe((data: any) => {
                if (data.ac_result != 1) {
                    localStorage.clear();
                    sessionStorage.clear();
                    this.__router.navigate(['/noauthorized']);
                } else {
                    this.user = data.ac_usuario;
                    // this.loadLastAssignments();
                }
            });
        } catch (e) {
            console.log(e);
            localStorage.clear();
            sessionStorage.clear();
            this.__router.navigate(['/noauthorized']);
        }
        this.assignationForm = this.fb.group({
            id: [null],
            areaId: [null, Validators.required],
            areaDescription: [null, Validators.required],
            isTeamService: [null],
            customerId: [null],
            customerName: [null],
            responsibleId: [null, [Validators.required]],
            responsibleName: [null, [Validators.required]],
            status: [true,]
        });

        this.assignment = this.config?.data;
        if (this.assignment) {
            const oldAssignationForm = {
                id: this.assignment.id,
                customerId: this.assignment.customerId,
                customerName: this.assignment.customerName,
                areaId: this.assignment.areaId,
                areaDescription: this.assignment.areaDescription,
                isTeamService: null,
                responsibleId: this.assignment.responsibleId,
                responsibleName: this.assignment.responsibleName,
                status: this.assignment.status == 1
            }
            this.assignationForm.setValue(oldAssignationForm);
        }
        
    }

    initializeTranslations() {
        // Set default language
        this.translate.setDefaultLang('en');
        
        // Get language from route parameter
        this.route.params.subscribe(params => {
            const lang = params['language'] || 'en';
            this.setLanguage(lang);
        });
    }

    setLanguage(lang: string) {
        // Normalize the language code
        const normalizedLang = this.normalizeLanguage(lang);
        
        // Use the normalized language, defaulting to 'IN' if not supported
        this.translate.use(this.isSupportedLanguage(normalizedLang.toUpperCase()) ? normalizedLang.toLowerCase() : 'en');
        this.currentLanguage = normalizedLang;
    }

    normalizeLanguage(lang: string): string {
        // Convert to uppercase to ensure consistency
        const uppercaseLang = lang.toUpperCase();
        
        // Map 'IN' to 'EN' for internal use (assuming 'IN' means English)
        return uppercaseLang === 'IN' ? 'EN' : uppercaseLang;
    }

    isSupportedLanguage(lang: string): boolean {
        // List of supported languages
        const supportedLanguages = ['EN', 'ES', 'PT'];
        return supportedLanguages.includes(lang);
    }
    closeModal() {
        this.ref.close();
    }

    saveAssignment() {
        this.assignmentRequest = this.assignationForm.getRawValue();
        this.assignmentRequest.status = this.assignmentRequest.status ? 1 : 0;
        this.assignmentRequest.language = this.currentLanguage;
        
    

        this.assigmentService.saveAssignment(this.assignmentRequest, this.user).subscribe({
            next: (resp) => {
                // Cierra el modal con la respuesta completa del servicio
                this.ref.close(resp); 
            },
            error: (err) => {
                console.error(err);
                this.messageService.add({
                    severity: 'error',
                    summary: this.translate.instant('general.error'),
                    detail: err.error.message
                });
            }
        });
    }
    
    searchCustomer() {
        const teamId = this.assignationForm.get('areaId')?.value;
        if (teamId) {
            this.showSearchDialog(null, this.translate.instant('search.customer'), 'CUSTOMER');
        } else {
            this.messageService.add({
                severity: 'warn',
                summary: this.translate.instant('general.wait'),
                detail: this.translate.instant('assignmentDialog.messages.selectTeamFirst'),
            });
            setTimeout(() => {
                this.messageService.clear();
            }, 3000);
        }
    }

    searchTeam() {
        this.showSearchDialog(null, this.translate.instant('search.team'), 'TEAM');
    }

    searchResponsible() {
        const teamId = this.assignationForm.get('areaId')?.value;
        if (teamId) {
            this.showSearchDialog(teamId, this.translate.instant('search.responsible'), 'RESPONSIBLE');
        } else {
            this.messageService.add({
                severity: 'warn',
                summary: this.translate.instant('general.wait'),
                detail: this.translate.instant('assignmentDialog.messages.selectTeamFirst')
            });
            setTimeout(() => {
                this.messageService.clear();
            }, 3000);
        }
    }

    showSearchDialog(data: any, header: string, collection: string) {
        const searchDialogRef = this.dialogService.open(SearchDialogComponent, {
            data: data,
            width: '50%',
            header: header,
            position: 'top',
            styleClass: 'custom-dialog-position-search',
            closable: true
        })!
        if (collection == 'TEAM') {
            searchDialogRef.onClose.subscribe({
                next: (data) => {
                    if (data) {
                        this.assignationForm.get('areaId')?.setValue(data.id);
                        this.assignationForm.get('areaDescription')?.setValue(data.description);
                        this.assignationForm.get('isTeamService')?.setValue(data.isService);
                    }
                }, error: (err) => {
                    console.log(err)
                }
            })
        } else if (collection == 'CUSTOMER') {
            searchDialogRef.onClose.subscribe({
                next: (data) => {
                    if (data) {
                        console.log(data);
                        this.assignationForm.get('customerId')?.setValue(data.id);
                        this.assignationForm.get('customerName')?.setValue(data.name);
                    }
                }, error: (err) => {
                    console.log(err)
                }
            })
        } else {
            searchDialogRef.onClose.subscribe({
                next: (data) => {
                    if (data) {
                        this.assignationForm.get('responsibleId')?.setValue(data.user);
                        this.assignationForm.get('responsibleName')?.setValue(data.name);
                    }
                }, error: (err) => {
                    console.log(err)
                }
            })
        }
    }
}
